

export enum AnalysisDosingFrequency {
  Single = 'single',
  SteadyState = 'steady-state'
}

export enum AnalysisDosingFrequencyType {
  Ev = 'ev',
  IvBolus = 'iv-bolus',
  IvInfusion = 'iv-infusion'
}